import React from 'react';
import {useTranslation} from 'react-i18next';

interface CustomToastContainerProps {
    message: string;
    buttonAction: () => void;
}
export default function CustomToastContainer(props: CustomToastContainerProps): JSX.Element {
    const {message, buttonAction} = props;

    const {t} = useTranslation();

    return (
        <div>
            <div>{message}</div>
            <button type="button" onClick={buttonAction} style={{textDecoration: 'underline'}} className="u-text-left">
                {t('editorPage.sharePresentations.sharePresentationModal.toastMessage.openSlideChangesPreview')}
            </button>
        </div>
    );
}
